<template>
  <div class="">
    <!-- 顶部区 -->
    <div class='top'>
      <Top></Top>
      <div class='line'></div>
      <div class='top_content'>
        <div>我们的使命</div>
        <!-- <el-divider></el-divider> -->
        <div class='top_title'>
          让影片分发快人一步！
        </div>
      </div>
    </div>

    <!-- 公司简介 -->
    <div class='brief vue_flex container'>
      <!-- 介绍 -->
      <div class='brief_content'>
        <div class='brief_title'>厦门飞影云科技有限公司</div>
        <div class='brief_title back' style='margin-top:5px;'>是一家引领电影行业科技革新的公司</div>
        <div class='brief_brief'>我们正在革新当前电影行业的发行和分发方式。以往，发行公司需要将影片DCP拷贝到移动硬盘，然后通过物流快递寄送到各个影院。</div>
        <div class='brief_brief'>然而，有了飞影云的出现，这一繁琐的分发流程得到了彻底改变。我们引入了先进的网络传输技术，使影片可以通过网络直接传输到各个影院。这一革新使得影片分发到影院的时间大幅缩短，拿到素材当天传输至全国。</div>
        <div class='brief_brief'>飞影云科技的使命是通过技术创新和高效的影片分发服务，为电影行业带来更便捷、快速和可靠的解决方案。我们致力于为电影产业的发展贡献力量，让电影从制片到观影的整个过程更加流畅和高效。</div>
      </div>
      <!-- 图片 -->
      <div class='brief_image'>
        <img src='../assets/pic2.jpg'/>
      </div>
    </div>
  </div>
</template>

<script>
import Top from '@/layout_web/top';
export default {
  components: {
		Top
	},
}
</script>

<style lang="scss" scoped>

// 顶部区
.top{
  position: relative;
  width: 100%;
  height:422px;
  background-image: url(../assets/banner1.jpg);
  background-repeat: no-repeat;
  background-size:cover;// 全覆盖
  background-position: center; //指定元素背景图片的位置
  // background-size: 100% 100%;
  .line{
    position: absolute;
    top: 72px;
    width: 100%;
    // margin: auto;
    height:1px; 
    background-color: rgba(77, 136, 255, 0.35);
  }
  .top_content{
    width: 1000px;
    margin: 0 auto;
    position: relative;
    top: -380px;
    // left: 24vw;
    font-size: 18px;
    font-family: 'MicrosoftYaHei';
    // margin:auto;
    color:#FFFFFF;
    display:flex;
    height:350px;
    flex-direction: column;// 主轴为垂直方向，起点在上沿
    justify-content:center;
    // align-items: center;
    // box-sizing:border-box;// 规定大小 不会因为边距改变
    .top_title{
      font-family: 'MicrosoftYaHei';
      font-size:28px;
      margin-top:10px;
    }
  }
}

// 公司简介
.brief{
  margin:50px auto 40px;
  // height:300px;
  .brief_content{
    width:44%;
    .brief_title{
      font-size:20px;
      // height:50px;
      line-height:25px;
      font-family: 'MicrosoftYaHei';
      color:#333333;
      padding-left: 5px;
    }
    .back{
      width: 330px;
      display: inline-block;
      background: linear-gradient(to bottom, transparent 50%, #D8E3FF 50%);
    }
    .brief_brief{
      font-size:14px;
      line-height:28px;
      margin-top:15px;
      // text-indent:28px;
      color:#777777;
    }
  }
  .brief_image{
    margin-top: 25px;
    width:50%;
    img{
      width:100%;
    }
  }
}
</style>
